import { URL_SERVICE } from "../shared/constants/api-constants";
import { axiosInstance } from '../shared/services/axios-instance';

class AuthenticationServices {
    // allows the log-in process
    static authentication(payload) {
        return axiosInstance.post(URL_SERVICE + "/authentication/api/v1/auth", payload).then(resp => resp.data)
    }
    // allows to recover the password
    static passwordRecovery(payload) {
        return axiosInstance.post(URL_SERVICE + "/recovery/api/v1/create-temporary-password", payload).then(resp => resp.data)
    }
    // forces the update of the password when the user enters with a provisional one
    static forceUpdatePassword(payload, config) {
        return axiosInstance.post(URL_SERVICE + "/recovery/api/v1/change-cognito", payload, config).then(resp => resp.data)
    }
}

export default AuthenticationServices;